import { render, staticRenderFns } from "./Meal_plan_checklist.vue?vue&type=template&id=31f18518&scoped=true&"
import script from "./Meal_plan_checklist.vue?vue&type=script&lang=js&"
export * from "./Meal_plan_checklist.vue?vue&type=script&lang=js&"
import style0 from "./Meal_plan_checklist.vue?vue&type=style&index=0&id=31f18518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f18518",
  null
  
)

export default component.exports